import { computeCheckDigitForResourceId } from "./computeCheckDigitForResource";

const SR_ID_LENGTH = 11;
const SR_ID_REGEX =
  /^(?<prefix>[\s\S])(?<number>[\s\S]{9})(?<check_digit>[\s\S])$/;
const SR_ID_PREFIX_REGEX = /^[AC]$/;
const SR_ID_NUMBER_REGEX = /^[A-Z0-9]{9}$/;
const SR_ID_CHECK_DIGIT_REGEX = /^\d$/;

/**
 * Validates a SR-ID and returns a specific error message for invalid parts.
 */
function isValidSrId(srId: string): true | string {
  if (srId.length !== SR_ID_LENGTH) {
    return "Die SR-ID muss genau 11 Zeichen lang sein.";
  }

  const match = SR_ID_REGEX.exec(srId);

  if (!match?.groups) return "Die SR-ID ist ungültig.";

  const { prefix, number, check_digit } = match.groups;

  if (!SR_ID_PREFIX_REGEX.test(prefix)) {
    return "Die SR-ID muss mit einem A oder C beginnen.";
  }

  if (!SR_ID_NUMBER_REGEX.test(number)) {
    return "Der Nummernteil der SR-ID muss aus 9 Großbuchstaben oder Ziffern bestehen.";
  }

  if (!SR_ID_CHECK_DIGIT_REGEX.test(check_digit)) {
    return "Die Prüfziffer der SR-ID muss eine Ziffer sein.";
  }

  if (computeCheckDigitForResourceId(prefix + number) !== Number(check_digit)) {
    return "Die Prüfziffer der SR-ID ist ungültig.";
  }

  return true;
}

export { isValidSrId };
